import React from 'react';

const PrevBtn = (props) => (
  <button {...props} >←</button>
);

export default PrevBtn;



// WEBPACK FOOTER //
// ./common/components/PrevBtn.js